import styled from '@emotion/styled';
import { Button } from 'components/Buttons';
import Typography from 'components/Typography/Typography';
import { pxToEm } from 'theme';
import palette from 'theme/palette';

export const AllCleared = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${pxToEm(116)};
  justify-content: center;
  align-items: center;
`;

export const DoneIcon = styled.div`
  background-color: ${palette.grey[200]};
  margin-bottom: ${pxToEm(24)};
  width: ${pxToEm(72)};
  height: ${pxToEm(72)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Description = styled(Typography)`
  color: ${palette.grey['A400']};
  margin: ${pxToEm(8)} 0 ${pxToEm(32)};
  text-align: center;
  max-width: ${pxToEm(450)};
`;

export const CloseButton = styled(Button)``;
